/* eslint-disable sciencepo-rules/require-story */
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import * as styles from '../../styles/layout/menu-item.module.scss';
import IconContainer from '../shared/IconContainer';
import PolyLink from '../shared/PolyLink';

const MenuItem = ({ activeSubmenu, isActive, item, toggleSubmenu, currentPath }) => {
  if (item.link && (!item.items || item.items.length === 0)) {
    return (
      <li className={styles.menuItem}>
        <PolyLink
          className={clsx(styles.menuLink, { [styles.active]: isActive })}
          url={item.link}
        >
          {item.title}
        </PolyLink>
      </li>
    );
  }
  const isSubmenuOpen = activeSubmenu === item.title;
  const isSubItemActive = item?.items?.some(subItem =>
    (subItem.link && currentPath.includes(subItem.link)) ||
    (subItem.items?.some(subSubItem => subSubItem.link && currentPath.includes(subSubItem.link)))
  );
  return (
    <li
      className={clsx(styles.menuItem, {
        [styles.submenuOpen]: isSubmenuOpen
      })}
    >
      <div className={styles.menuItemWrapper}>
        {item.link ? (
          <PolyLink
            aria-expanded={isSubmenuOpen}
            className={clsx(styles.menuButton, {
              [styles.active]: isSubmenuOpen || isActive || isSubItemActive
            })}
            url={item.link}
          >
            {item.title}
          </PolyLink>
        ) : (
          <button
            aria-expanded={isSubmenuOpen}
            className={clsx(styles.menuButton, {
              [styles.active]: isSubmenuOpen || isActive || isSubItemActive
            })}
          >
            {item.title}
          </button>
        )}
        <button
          aria-label={`Toggle ${item.title} submenu`}
          className={styles.submenuToggle}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleSubmenu(item.title);
          }}
        >
          <IconContainer
            color={'WHITE'}
            icon={isSubmenuOpen ? 'ARROW_UP_SMALL' : 'ARROW_DOWN_SMALL'}
            noHover
            notFocus
            size={15}
          />
        </button>
      </div>
      <ul className={styles.submenu}>
        {item.items.map((subItem, index) => (
          <li
            className={styles.submenuItem}
            key={index}
          >
            {!subItem.items ? (
              <PolyLink
                className={clsx(styles.submenuLink, {
                  [styles.active]: subItem.link && currentPath.includes(subItem.link)
                })}
                url={subItem.link}
              >
                <span className={styles.submenuArrow}></span>
                <span className={styles.submenuText}>{subItem.title}</span>
              </PolyLink>
            ) : (
              <>
                <PolyLink
                  className={clsx(styles.submenuLink, {
                    [styles.active]: (subItem.link && currentPath.includes(subItem.link)) ||
                      (subItem.items?.some(subSubItem => subSubItem.link && currentPath.includes(subSubItem.link)))
                  })}
                  url={subItem.link || '#'}
                >
                  <span className={styles.submenuArrow}></span>
                  <span className={styles.submenuText}>{subItem.title}</span>
                </PolyLink>
                <ul className={styles.subSubmenu}>
                  {subItem.items.map((subSubItem, subIndex) => (
                    <li className={styles.subSubmenuItem}
                      key={subIndex}
                    >
                      <PolyLink
                        className={clsx(styles.subSubmenuLink, {
                          [styles.active]: subSubItem.link && currentPath.includes(subSubItem.link)
                        })}
                        url={subSubItem.link}
                      >
                        <span className={styles.submenuArrow}></span>
                        <span className={styles.submenuText}>{subSubItem.title}</span>
                      </PolyLink>
                    </li>
                  ))}
                </ul>
              </>
            )}
          </li>
        ))}
      </ul>
    </li>
  );
};

MenuItem.propTypes = {
  activeSubmenu: PropTypes.bool,
  currentPath: PropTypes.string,
  isActive: PropTypes.bool,
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    link: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        link: PropTypes.string,
        items: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string.isRequired,
            link: PropTypes.string.isRequired,
            items: PropTypes.arrayOf(PropTypes.object)
          })
        )
      })
    )
  }).isRequired,
  toggleSubmenu: PropTypes.func
};

export default MenuItem;